import { parseStream, parseStringSync, formatSync, formatStream, formatFile, } from './api';
import * as util from './util';
export default {
    parseStream,
    parseStringSync,
    formatSync,
    formatStream,
    formatFile,
    util,
};
//# sourceMappingURL=index.js.map